import React from 'react';
import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { usePageSidebarContext } from '~/eds/src/components/PageSidebar/PageSidebarContext';
import { Panel } from '~/eds/src/components/Panel/Panel';
import { SearchInput } from '~/eds/src/components/SearchInput/SearchInput';
import { useThrottledState } from '~/eds/src/hooks/useThrottledState';
import { Uuid } from '~/eds/src/types/Uuid';
import { Nullable } from '~/types/Nullable';
import { TicketDocumentVersion } from '~/types/Ticket';

import { ActivityLog } from './ActivityLog';
import { CustomActions } from './types';

interface Props {
  customActions?: CustomActions;
  ticketId: Uuid;
  versions: TicketDocumentVersion[];
}

export function ActivityLogPanel({ customActions, ticketId, versions }: Props) {
  const [throttledSearch, search, setSearch] =
    useThrottledState<Nullable<string>>('');

  const intl = useIntl();
  const pageSidebarContext = usePageSidebarContext();
  return (
    <Panel
      enableMaximize
      expandWidth="680px"
      width="560px"
      onWidthChange={(w) => pageSidebarContext?.setEffectiveWidth?.(w)}
      enableContentPadding={true}
      title={intl.formatMessage({
        id: 'ActivityLogPanel.title',
        defaultMessage: 'Activity Log',
        description: 'Title of the activity log panel',
      })}
    >
      <Layout h="100%" direction="column" spacing={4}>
        <SearchInput
          name="search"
          placeholder={intl.formatMessage({
            id: 'ActivityLogPanel.searchPlaceholder',
            defaultMessage: 'Search Activities',
            description:
              'Placeholder text for search input in activity log panel',
          })}
          value={search}
          onChange={setSearch}
        />
        <Layout overflowY="auto">
          <ActivityLog
            ticketId={ticketId}
            versions={versions}
            searchInput={throttledSearch ?? ''}
            customActions={customActions}
          />
        </Layout>
      </Layout>
    </Panel>
  );
}
